<template>
    <h1> Перенаправление... </h1>
</template>

<script>

export default {
  name: 'notFoundPage',
  mounted () {
    console.log('redirect')
    this.$router.push(this.$store.getters.getDefaultPath)
  }
}
</script>
